var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogomark = function SvgLogomark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logomark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.01 24.103A32 32 0 1 0 .99 39.898a32 32 0 0 0 62.02-15.795ZM48.496 40.717a1.336 1.336 0 0 1-.667 1.158l-15.153 8.749a1.336 1.336 0 0 1-1.337 0l-15.15-8.75a1.335 1.335 0 0 1-.67-1.157V23.22a1.335 1.335 0 0 1 .67-1.157l15.15-8.752a1.336 1.336 0 0 1 1.337 0l15.153 8.747a1.337 1.337 0 0 1 .667 1.158v17.5Z",
    fill: "#002A1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logomark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};
export default SvgLogomark;